import { analyticsDashboard as TYPES } from './../action_types';
import * as ModelFetchers from './../util/model_fetchers';
import { dateParams as dateParamsUtil } from './utilities';
import _ from 'underscore';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Works.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Works.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_WORKS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    ModelFetchers.Docs(dateParams)
      .done(function (docs) {
        const cv = _.find(docs, function (doc) {
          return doc.id === Aedu.WorkConstants.CV_WORK_ID;
        });

        dispatch({
          type: TYPES.FETCH_WORKS_SUCCESS,
          works: _.without(docs, cv),
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_DOCS_FAILURE,
        });
      });
  };
};

const Works = {
  fetch: fetch,
};
export { Works };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_WORKS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_WORKS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.works),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_WORKS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
